import type { GameEvent, World } from '../sim/types';
import { epochDayOf } from '../sim/calendar';
import { heatStressToday } from '../sim/systems/heatStress';
import { ALERT_LEVELS } from '../sim/heatStress';

/**
 * Why an advance stopped, in a line (M289, the playtest's heatwave point: the advance stopped for a marine heatwave while
 * the dashboard read "no heat stress"). A marine heatwave is the surface warm for its date (Hobday's 90th percentile,
 * `climate.ts`); bleaching heat stress is warmth past the summer's warmest month accumulated over weeks (NOAA Coral Reef
 * Watch's Degree Heating Weeks, `heatStress.ts`). The first can come without the second, and the line says which.
 */
export function stopWords(world: World, e: GameEvent): string {
  const head = `Stopped early: ${e.title}.`;
  const s = world.sanctuaries[0];
  if (!s || !e.title.startsWith('A marine heatwave')) return `${head} Press Advance again to run on.`;
  const level = heatStressToday(s, epochDayOf(world))?.level ?? ALERT_LEVELS[0];
  const heat = level === ALERT_LEVELS[0] ? 'Unusually warm for the season; no coral bleaching heat stress yet.' : `Unusually warm for the season, and the coral under heat stress: ${level}.`;
  return `${head} ${heat} Press Advance again to run on.`;
}
